<template>
  <app-panel nested icon="map" title="Tarifzonen" flush>
    <template #actions>
      <app-icon-button icon="refresh" label="Aktualisieren" @click="refreshDataGrid" />
      <app-icon-button icon="plus" label="Tarifzone anlegen" @click="addRow" />
    </template>
    <dx-data-grid
      :ref="gridRefName"
      :columns="columns"
      :data-source="dataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      :hover-state-enabled="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :allow-column-reordering="!gridTouch"
      :scrolling="scrolling"
      :element-attr="gridAttr"
      :column-auto-width="true"
      :focused-row-enabled="true"
      @focused-row-changed="onFocusedRowChanged"
      :focused-row-index="0"
      @toolbar-preparing="onToolbarPreparing"
      @editing-start="onEditingStart"
      @row-inserting="onDataChanged"
      @row-updating="onDataChanged"
      @row-removing="onDataChanged"
    >
      <dx-paging :page-size="5" />
      <dx-editing refresh-mode="full" :allow-adding="false" mode="batch" />
    </dx-data-grid>
    <app-save-bar
      v-if="hasChanges"
      class="panel-savebar"
      @save="saveChanges"
      @discard="revertChanges"
    />
  </app-panel>
</template>

<script>
import { DxDataGrid, DxPaging, DxEditing } from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";

export default {
  components: {
    DxDataGrid,
    DxPaging,
    DxEditing,
  },
  mixins: [DataGridMixin],
  data() {
    return {
      gridRefName: "tariffZoneDataGrid",
      hasChanges: false,
      // Zeiger auf den Zeilen (Maus): die gewählte Tarifzone steuert die übrigen Bereiche der Seite
      gridAttr: { class: "app-grid--detail" },
      columns: [
        {
          dataField: "tariff_zone_id",
          caption: "ID",
        },
        {
          dataField: "name",
          caption: "Tarifzone",
        },
        {
          dataField: "permission",
          caption: "Berechtigung",
          lookup: {
            dataSource: {
              store: {
                type: "array",
                data: [
                  { permission: "READ", name: "Lesen" },
                  { permission: "WRITE", name: "Lesen und Schreiben" },
                ],
                key: "permission",
              },
            },
            valueExpr: "permission",
            displayExpr: "name",
          },
        },
      ],
      dataSource: new CustomStore({
        key: ["tariff_zone_id"],
        load: () => axios.get(`${this.$store.state.baseUrl}tariffzone`),
        insert: (newTariffZone) =>
          axios.post(`${this.$store.state.baseUrl}tariffzone`, newTariffZone),
      }),
    };
  },
  methods: {
    onToolbarPreparing(e) {
      // Remove all default toolbar items
      e.toolbarOptions.items = [];
    },
    onEditingStart(e) {
      if (e && e.data) {
        this.hasChanges = true;
      }
    },
    onDataChanged(e) {
      if (e && e.data) {
        this.hasChanges = true;
      }
    },
    addRow() {
      this.$refs[this.gridRefName].instance.addRow();
    },
    async saveChanges() {
      await this.$refs[this.gridRefName].instance.saveEditData();
      this.hasChanges = false;
    },
    revertChanges() {
      this.$refs[this.gridRefName].instance.cancelEditData();
      this.hasChanges = false;
    },
    refreshDataGrid() {
      this.$refs[this.gridRefName].instance.refresh();
    },
    onFocusedRowChanged(e) {
      this.$emit("onTariffzoneSelected", e.row.data);
    },
  },
};
</script>

<style scoped>
/* Speichern-Leiste als Fuß der Karte: .app-panel schneidet (overflow: hidden) und wird damit zum Bezugsrahmen von
   position: sticky; bottom: var(--sticky-unten) würde sie dort auf dem Handy um die untere Navigation anheben. */
.panel-savebar {
  position: static;
}
</style>
